import { getSdiraBusinessName } from "@components/Dwolla";

import isSdiraInvestment from "../../../../../helpers/isSdiraInvestment";
import isEntityInvestment from "../../../../../helpers/isEntityInvestment";
import type { Investment } from "../../../../types";

type OnSelect = (receiverSourceId: string) => Promise<void>;

export type ConnectSourceProps = {
  sourceId?: string;
  onSelect: OnSelect;
  investment: Investment;
  businessName?: string;
  dropdownProps: { isPlaidDisabled: boolean };
  isReceiveOnly: boolean;
  isVerificationRequired: boolean;
  impersonatedInvestorAccountId: string;
};

const getConnectSourceProps = (investment: Investment, onSelect: OnSelect): ConnectSourceProps => {
  const {
    name: businessName,
    receiverSourceId: sourceId,
    investorAccountId,
  } = investment;

  const props: ConnectSourceProps = {
    dropdownProps: { isPlaidDisabled: true },
    isReceiveOnly: false,
    isVerificationRequired: false,
    impersonatedInvestorAccountId: investorAccountId,
    onSelect,
    sourceId,
    investment,
  };

  const isEntity = isEntityInvestment(investment);

  if (isEntity) {
    props.businessName = businessName;
  }

  const isSdira = isSdiraInvestment(investment);

  if (isSdira) {
    props.businessName = getSdiraBusinessName(businessName);
    props.isReceiveOnly = true;
  }

  return props;
};

export default getConnectSourceProps;
